type ThemeStrings = Record<string, string>;

const DEFAULT_STRINGS: ThemeStrings = {
  "cart.error.default": "Failed to add items to the cart. Please try again.",
  "cart.error.invalid_selection":
    "Please select one option for each product in the bundle.",
  "cart.error.invalid_variant":
    "One of the selected variants is invalid. Please check your selections.",
  "cart.error.invalid_quantity": "Invalid quantity. Please enter a valid number.",
  "cart.error.element_not_found": "Required element not found: {selector}",
  "cart.error.invalid_request":
    "Invalid request. Please check your selections.",
  "cart.error.not_found":
    "Selected item not found. It may no longer be available.",
  "cart.error.unprocessable":
    "There was an issue with the items selected (e.g., unavailable or invalid). Please review your selection.",
  "cart.error.server_error": "Server error. Please try again later.",
  "cart.error.unexpected": "An unexpected error occurred. Please try again.",
};

const themeVariables = (window.themeVariables = window.themeVariables ?? {});
themeVariables.strings = { ...DEFAULT_STRINGS, ...(themeVariables.strings ?? {}) };

export const translate = (key: string, fallback: string): string => {
  const message = window.themeVariables?.strings?.[key];
  return typeof message === "string" && message.trim() ? message : fallback;
};

type Keys = keyof typeof DEFAULT_STRINGS;
const get = (key: Keys): string => {
  const message = window.themeVariables?.strings?.[key];
  return typeof message === "string" && message.trim() ? message : DEFAULT_STRINGS[key];
};

type ErrorMessages = {
  readonly DEFAULT: string;
  readonly INVALID_SELECTION: string;
  readonly INVALID_VARIANT: string;
  readonly INVALID_QUANTITY: string;
  readonly INVALID_REQUEST: string;
  readonly NOT_FOUND: string;
  readonly UNPROCESSABLE: string;
  readonly SERVER_ERROR: string;
  readonly UNEXPECTED: string;
};

export const ERR: ErrorMessages = {
  DEFAULT: get("cart.error.default"),
  INVALID_SELECTION: get("cart.error.invalid_selection"),
  INVALID_VARIANT: get("cart.error.invalid_variant"),
  INVALID_QUANTITY: get("cart.error.invalid_quantity"),
  INVALID_REQUEST: get("cart.error.invalid_request"),
  NOT_FOUND: get("cart.error.not_found"),
  UNPROCESSABLE: get("cart.error.unprocessable"),
  SERVER_ERROR: get("cart.error.server_error"),
  UNEXPECTED: get("cart.error.unexpected"),
};

export const errorElementNotFound = (selector: string): string =>
  get("cart.error.element_not_found").replace("{selector}", selector);
